<template>
  <div id="careers-page" class="main-page">
      <div class="gs-customization">
          <div class="container">
              <p v-if="!status" style="text-align:center;">This key is invalid, please 
                <router-link
                  :to="{ name: 'about-gunspring' }"
                >contact support</router-link>.
              </p>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      key: null,
      status: false,
      err: ""
    };
  },
  beforeCreate() {
    this.$store
      .dispatch("emailConfirm", {
        key: this.$route.params.key
      })
      .then(res => {
        this.$router.push({ name: "login", query: { message: "confirmed" } });
      })
      .catch(error => {
        this.err = error.data.key[0];
      });
  },
  created() {
    this.key = this.$route.params.key;
    this.$store
      .dispatch("emailConfirm", {
        key: this.key
      })
      .then(res => {
        this.status = true;
        this.$router.push({ name: "login", query: { message: "confirmed" } });
      })
      .catch(error => {
        this.status = false;
        this.err = error.data.key[0];
      });
  },
  mounted() {}
};
</script>

<style>
</style>